export default {
    parent: 'PublicLayout',
    url: '',
    template: '<root />',
    controller (CompanyService) {
        // use coursy default skin from config on public dashboard
        CompanyService.loadSkin(SEED_CORE.ENV.SKIN);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/root/index.js